<page-headline
    [linkTitle]="'Performance Insights'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
<div class="row-layout-track-left-align layout-padding-bottom__1rem">
    <div class="">
        <div class="kpi-position-ddl">
            <angular2-multiselect
                [data]="positions"
                *ngIf="roleName === 'Employee'"
                [(ngModel)]="selectedPosition"
                [settings]="kpiProfileSettings"
                (onSelect)="onSelectionChangeProfile($event)"
                (onDeSelect)="onDeSelectProfile($event)"
            >
            </angular2-multiselect>
        </div>
        <div class="kpi-items-ddl">
            <angular2-multiselect
                [data]="KPIs"
                [(ngModel)]="selectedKPI"
                [settings]="kpiListSettings"
                (onSelect)="onSelectionChange($event)"
                (onDeSelect)="onDeSelect($event)"
            >
            </angular2-multiselect>
        </div>
    </div>

    <div class="displayopt-actionpanel-layout">
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [showCompareToDate]="false"
            [syncAsOfDateInf]="syncAsOfDateInf"
        >
        </display-options>
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageHeadline.pageTitle"
        >
        </action-panel>
    </div>
</div>
<div>
    <custom-mat-table
        [customTableInfo]="customTableInfo"
        (contentChanged)="contentChanged($event)"
        (cellClickedEvent)="cellClickedEvent($event)"
    ></custom-mat-table>
</div>
